



































































































































































import { Component, Vue } from 'vue-property-decorator'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import PickupTextInput from '../components/PickupTextInput/index.vue'
import controller from '@/app/ui/controllers/PickupController'
import { PickupDetail, PickupDetailSnapshot } from '@/domain/entities/Pickup'
import dayjs from 'dayjs'
import dayjsID from 'dayjs/locale/id'
import { EventBus, EventBusConstants } from '@/app/infrastructures/misc'
import { EnumPickupFlag } from '@/app/infrastructures/misc/Constants/pickup'
import router from '@/app/ui/router'

@Component({
  components: {
    LoadingOverlay,
    PickupTextInput,
    Button
  },
})
export default class PickupDetailPage extends Vue {
  enumPickupFlag = EnumPickupFlag

  created(): void {
    controller.getPickupDetail(this.$route.params.shipmentId)
    controller.getPickupSnapshotDetail(this.$route.params.shipmentId)
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    EventBus.$on(EventBusConstants.CANCEL_PICKUP_SUCCESS, (success: boolean) => {
      Vue.notify({
        title: 'Pickup Cancelled',
        text: `Order ${controller.pickupDetail.shipmentId} is successfully cancelled`,
        type: 'success',
        duration: 5000,
      })

      if (success) {
        router.push({
          name: 'PickupCRRDON',
          query: { refetch: 'true' }
        })
      }
    })
  }

  cancelReason = ""
  hasChanged = {
    cancelReason: false
  }

  get pickupDetail(): PickupDetail {
    return controller.pickupDetail
  }

  get pickupSnapshotDetail(): PickupDetailSnapshot[] {
    return controller.pickupSnapshotDetail
  }

  get isLoading(): boolean {
    return controller.isLoading
  }

  get statusId(): string {
    return (
      (this.$route.meta.additional.statusId as string) ||
      this.pickupDetail.flag ||
      '-'
    )
  }

  get origin(): string {
    return `${this.pickupDetail.pickup?.district}, ${this.pickupDetail.pickup?.subDistrict}, ${this.pickupDetail.pickup?.village}`
  }

  get shipmentDate(): string {
    if (!this.pickupDetail.createdAt) {
      return ''
    }

    return dayjs(this.pickupDetail.createdAt)
      .locale(dayjsID)
      .format('DD MMM YYYY HH:mm [WIB]')
  }

  get isCancelPickup(): boolean {
    return this.$route.meta.additional?.isCancel ? true : false
  }

  get markAsDoneRouteTo(): string {
    if (this.pickupDetail.flag === this.enumPickupFlag.CRROTW) {
      return 'PickupCRROTWMarkAsDone'
    }

    if (this.pickupDetail.flag === this.enumPickupFlag.DOLOTW) {
      return 'PickupCRROTWMarkAsDone'
    }

    if (this.pickupDetail.flag === this.enumPickupFlag.CRRPIC) {
      return 'PickupCRRPICMarkAsDone'
    }

    return ''
  }

  get showMarkAsDoneButton(): boolean {
    if (
      this.pickupDetail.histories &&
      this.pickupDetail.histories.length !== 0
    ) {
      if (this.pickupDetail.flag === this.enumPickupFlag.CRRPIC) {
        return true
      }

      if (this.pickupDetail.flag === this.enumPickupFlag.CRROTW) {
        return true
      }

      if (this.pickupDetail.flag === this.enumPickupFlag.DOLOTW) {
        return true
      }
    }

    return false
  }

  private historyDate(date: string): string {
    return dayjs(date)
      .locale(dayjsID)
      .format('DD MMMM YYYY HH:mm [WIB]')
  }

  private onSubmitCancel() {
    if (controller.pickupDetail.shipmentId) {
      controller.cancelPickup({
        shipmentId: controller.pickupDetail.shipmentId,
        note: this.cancelReason,
      })
    }
  }

  beforeDestroy(): void {
    EventBus.$off(EventBusConstants.CANCEL_PICKUP_SUCCESS)
  }

}
